import React from 'react';
import { useTranslation } from 'react-i18next';
import { NavLink } from 'react-router-dom';

const TabNav: React.FC = () => {
  const { t } = useTranslation();
  return (
    <div className="grid grid-cols-2">
      <NavLink
        to="/"
        className={({ isActive }): string =>
          `h-full p-4 flex items-center justify-center col-span-1 border-none no-animation cursor-pointer leading-3 ${
            isActive && 'btn-disabled !bg-transparent'
          } ${!isActive && 'bg-[#e6e6e6] shadow-inner'}`
        }
      >
        <h3>{t('nav.cloud_tab')}</h3>
      </NavLink>
      <NavLink
        to="/apollo"
        className={({ isActive }): string =>
          `h-full p-4 flex items-center justify-center col-span-1 text-3xl border-none no-animation cursor-pointer ${
            isActive && 'btn-disabled !bg-transparent'
          } ${!isActive && 'bg-[#e6e6e6] shadow-inner'}`
        }
      >
        <h3>{t('nav.apollo_tab')}</h3>
      </NavLink>
    </div>
  );
};

export default TabNav;
